export default function parseNMEA(obj) {
  const date = obj.createdAt;

  const lat = typeof obj.lat === "number" ? obj.lat : parseFloat(obj.lat);
  const lon = typeof obj.lon === "number" ? obj.lon : parseFloat(obj.lon);
  const height = typeof obj.alt === "number" ? obj.alt : parseFloat(obj.alt);

  let quality;
  switch (obj.quality) {
    case "1":
      quality = "Standalone";
      break;
    case "2":
      quality = "DGPS";
      break;
    case "4":
      quality = "Fix";
      break;
    case "5":
      quality = "Float";
      break;
    default:
      quality = "None";
      break;
  }

  return {
    date,
    lat,
    lon,
    height,
    quality,
  };
}
